import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0930. 発注案件契約タスクコメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id/purchase_order_contract_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};
const purchaseOrderContractTaskComments = (props: Props): Promise<PurchaseOrderContractTaskComment[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_comments`
  );
};

export const usePurchaseOrderContractTaskComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderContractTaskComments(props),
  });
};

export const usePurchaseOrderContractTaskCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'purchase_order_contract_tasks',
    props.task_id,
    'purchase_order_contract_task_comments',
  ];
};
